import * as yup from 'yup'
import { DEFAULT_REQUIRED_MESSAGE } from 'src/utils'

yup.setLocale({
  mixed: {
    required: DEFAULT_REQUIRED_MESSAGE
  }
})

export const validationSchema = yup.object().shape({
  keyCode: yup.string().required()
})
